const parseSearch = (searchString: string): Record<string, string> => {
  const params = new URLSearchParams(searchString || '');
  const result: Record<string, string> = {};
  params.forEach((value, key) => {
    result[key] = value;
  });
  return result;
};

const stringifySearch = (query: Record<string, unknown>): string =>
  Object.entries(query)
    .filter(([, v]) => v != null)
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([k, v]) => `${k}=${v}`)
    .join('&');

export const getValueFromQueryString = (searchString: string, key: string): string | null => {
  const query = parseSearch(searchString);
  if (query[key]) {
    return query[key];
  }
  return null;
};

export const getValuesFromQueryString = (searchString: string, keys: string[]) => {
  if (!keys) {
    return {};
  }

  const query = parseSearch(searchString);
  if (!query) {
    return {};
  }

  return keys.reduce((acc, curr) => {
    if (query[curr]) {
      acc[curr] = query[curr];
    }
    return acc;
  }, {});
};

export const removeFromSearchString = (
  searchString: string,
  toRemove: string | string[]
): string => {
  const query = parseSearch(searchString);
  let toRemoveClone = toRemove;
  if (!Array.isArray(toRemove)) {
    toRemoveClone = Array(toRemove);
  }

  for (const i of toRemoveClone) {
    delete query[i];
  }
  return stringifySearch(query);
};

export const addToSearchString = (
  searchString: string,
  toAdd: Record<string, string | number>
): string => {
  const query = {
    ...parseSearch(searchString),
    ...toAdd,
  };
  return stringifySearch(query);
};
